import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[bui-divider]'
})

export class DataDividerDirective {
  @HostBinding(`class.ant-divider`) true;
}
